module.exports = __webpack_public_path__ + "assets/199724fdb3b7e0c1eabccc8c067b7e01.svg";